import './Profile.scss'
import { Link } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import AvatarBig from 'Components/Svgs/AvatarBig'
import XSvg from 'Components/Svgs/XSvg'
import FacebookSvg from 'Components/Svgs/FacebookSvg'
import InstagramSvg from 'Components/Svgs/InstagramSvg'
import LinkedInSvg from 'Components/Svgs/LinkedInSvg'
import { useResolvedProfile } from 'Hooks/useResolvedProfile'
import { getRoleBadge } from 'Helpers/getRoleBadge'
import EditIcon from 'Assets/Icons/edit-2.png'
import Swal from 'sweetalert2'
import { ChangeEvent, useState } from 'react'
import uploadDocumentService from 'Services/uploadDocumentService'
import { useEmployeeProfile } from 'Context/ProfileContext'
import { ImageCompressor } from 'Helpers'

const Profile = () => {
  const { profile } = useResolvedProfile()
  const { refreshProfile } = useEmployeeProfile()
  const roleBadge = getRoleBadge(profile?.role)

  // console.log('profile here', profile)

  const [uploading, setUploading] = useState(false)

  const uploadFile = async (e: ChangeEvent<HTMLInputElement>) => {
    setUploading(true)

    const file = e.target.files?.[0]

    if (!file) {
      Swal.fire({
        icon: 'warning',
        title: 'No file selected',
        text: 'Please select a file to upload.',
        showConfirmButton: false,
        timer: 3000,
      })
      setUploading(false)
      return
    }

    // const maxSize = 300 * 1024
    // if (file.size > maxSize) {
    //   Swal.fire({
    //     icon: 'error',
    //     title: 'File too large',
    //     text: 'Maximum allowed size is 300KB',
    //   })
    //   setUploading(false)
    //   return
    // }

    // const maxWidth = 800
    // const maxHeight = 800

    const img = new Image()
    img.src = URL.createObjectURL(file)

    // validate img before allowing upload
    img.onload = async () => {
      // if (img.width > maxWidth || img.height > maxHeight) {
      //   Swal.fire({
      //     icon: 'error',
      //     title: 'Invalid dimensions',
      //     text: `Max allowed is ${maxWidth}x${maxHeight}px`,
      //   })
      //   setUploading(false)
      //   return
      // }

      const compressedFile = await ImageCompressor(file)
      const formData = new FormData()
      // Update the formData object
      formData.append('file', compressedFile)

      await uploadDocumentService.upload('USER_PROFILE_PHOTO', profile?.id, formData).then(
        () => {
          setUploading(false)
          Swal.fire({
            icon: 'success',
            text: 'Headshot uploaded succesfully',
            showConfirmButton: false,
            timer: 3000,
          })
          refreshProfile()
        },
        (error) => {
          setUploading(false)
          Swal.fire({
            icon: 'warning',
            title: 'Oops!',
            text: error.response.data.error,
            showConfirmButton: false,
            timer: 3000,
          })
        },
      )
    }

    img.onerror = () => {
      Swal.fire({
        icon: 'error',
        title: 'Invalid file',
        text: 'Please select a valid image file.',
      })
      setUploading(false)
    }
  }

  const [showPhoto, setShowPhoto] = useState(false)

  return (
    <div className='Profile'>
      <div className='card px-4 border-0 shaddow-sm'>
        <div className='card-body'>
          <div className='row p-top'>
            <div className='col-12 col-sm-6 col-md-4 col-xl-2 shift-left-sm my-auto mt-0'>
              {/* <div className='profile-icon'>
                {profile?.photo ? (
                  <img
                    src={profile?.photo.url}
                    alt={profile?.firstName}
                    className='profile-photo'
                  ></img>
                ) : (
                  <AvatarBig />
                )}
                <span className='verified-badge'>✔</span>
              </div> */}
              <div className='profile-icon-two'>
                {profile?.photo?.url ? (
                  <span
                    // type='button'
                    className='profile-photo-button'
                    onClick={() => setShowPhoto(true)}
                    aria-label='View profile photo'
                  >
                    <img
                      src={profile?.photo.url}
                      alt={profile?.firstName}
                      className='profile-photo-two'
                    />
                  </span>
                ) : (
                  <AvatarBig />
                )}

                <button
                  type='button'
                  onClick={() => {
                    document.getElementById('upload_photo')?.click()
                  }}
                  className='edit-btn'
                >
                  <img src={EditIcon} alt='edit' />
                  {uploading && <span className='spinner-border spinner-border-sm'></span>}
                </button>
                <input
                  type='file'
                  id='upload_photo'
                  className='d-none'
                  onChange={uploadFile}
                ></input>
              </div>

              {showPhoto && profile?.photo?.url && (
                <div className='profile-photo-modal' onClick={() => setShowPhoto(false)}>
                  <div className='profile-photo-modal-content' onClick={(e) => e.stopPropagation()}>
                    <button
                      type='button'
                      className='profile-photo-close'
                      onClick={() => setShowPhoto(false)}
                      aria-label='Close'
                    >
                      &times;
                    </button>

                    <img
                      src={profile.photo.url}
                      alt={profile?.firstName}
                      className='profile-photo-large'
                    />
                  </div>
                </div>
              )}
            </div>

            <div className='col-12 col-sm-7 col-md-4 col-xl-6 shift-left my-auto'>
              <div className='name'>
                <span className='me-lg-2'>
                  {profile ? profile.firstName + ' ' + profile.lastName : <Skeleton />}
                </span>
                <span className='text-capitalize emp-status none me-lg-3'>
                  {profile ? profile.employmentStatus : <Skeleton />}
                </span>
                <span
                  className={`badge rounded-pill d-inline-flex align-items-center gap-1 fs-6 d-none d-md-inline-block ${roleBadge.className}`}
                >
                  <i className={`bi me-lg-1 ${roleBadge.icon}`}></i>
                  {roleBadge.label}
                </span>
              </div>
              <div className='user-role'>{profile ? profile.jobTitle : <Skeleton />}</div>
            </div>

            <div className='col-12 col-sm-5 col-md-4 col-xl-4 shift-right text-lg-end my-auto mobile-active-edit'>
              <div className='text-capitalize emp-status d-md-none'>
                {profile ? profile.employmentStatus : <Skeleton />}
              </div>
              <div className='profile-action'>
                <a href='#pills-tab'>
                  <button className='btn'>Edit Profile</button>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className='card-footer'>
          <div className='row align-items-center'>
            <div className='col-12 col-sm-12 col-md-5 col-lg-3'>
              <div className='email d-none'>{profile ? profile.emailAddress : <Skeleton />}</div>
              <div className='email'>
                {profile && (
                  <div className='okay'>
                    <span className='text-end text-muted me-2'>Employee ID</span>
                    <span className='text-end me-2 emp-value'>{profile?.employeeDisplayId}</span>
                    {/* <span className='text-muted me-1'>Role:</span> */}
                    <span
                      className={`badge rounded-pill d-inline-flex align-items-center gap-1 fs-6 d-none ${roleBadge.className}`}
                    >
                      <i className={`bi me-lg-1 ${roleBadge.icon}`}></i>
                      {roleBadge.label}
                    </span>
                  </div>
                )}
              </div>
            </div>
            <div className='col-12 col-sm-8 col-lg-6'>
              <div className='department okay'>
                <span className='me-2 text-muted'>Department</span>
                <span className='emp-value'>
                  {profile ? (
                    profile.department ? (
                      profile.department
                    ) : (
                      'No department'
                    )
                  ) : (
                    <Skeleton />
                  )}
                </span>
              </div>
            </div>
            <div className='col-12 text-center col-sm-4 col-lg-3 text-md-end'>
              <div className='social'>
                <LinkedInSvg />
                <InstagramSvg />
                <FacebookSvg />
                <XSvg />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Profile
